import { useBaseDelete } from "../../base/hooks/useBaseDelete";
import { DeletePaymentResponse, DeletePaymentResponseSchema } from "../response/DeletePaymentResponse";

const API_VERSION = "v3";

export const useDeletePayment = () => {
    return useBaseDelete<{ id: string }, DeletePaymentResponse>({
        endpoint: ({ id }) => `${API_VERSION}/payment/${id}`,
        schema: DeletePaymentResponseSchema,
        onSuccess: (data) => data,
        onError: (error) => {
            throw error;
        },
    });
};